(function(){
    'use strict'

    angular.module('app.companias')
    .factory('CompaniasService', CompaniasService);

    CompaniasService.$inject = ['$http', '$q', 'apiSettings', 'UserInfoService'];

    function CompaniasService($http, $q, apiSettings, UserInfoService) {

        var api = {
            getAll: getAll
        };

        return api;

        function getAll(){

            var url = apiSettings.apiBaseUrl + 'api/companias/';
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

    };

})();